<header class="pc-header coded-header">
  <div class="header-wrapper">
    <app-nav-left (NavCollapsedMob)="navCollapseMob()" />
    <app-nav-right />
  </div>
</header>
